import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref, onMounted } from 'vue'
import DefaultHeader from "@/components/Headers/DefaultHeader.vue";
import DefaultFooter from "@/components/Footers/DefaultFooter.vue";
import Slide from '@/layouts/default/profile/SlideProfile.vue'
import Social from '@/components/social/Social.vue'

import { useRouter, useRoute } from "vue-router";
// import { USER_REF } from '@/const/localStorage'
// import commons from '../utils/Common';
// import { localhostPost, apiPost, apiGetNoParam } from "@/api/index";
// import { USER_V1_LOGIN } from "@/api/const/users";

export default /*#__PURE__*/_defineComponent({
  __name: 'DefaultProfile',
  setup(__props) {

const route = useRoute();

// onMounted(()=>{
// 	let ref = route.query.ref || '';
// 	if(ref != '') {
// 		commons.setLocalStorage(USER_REF, ref)
// 		login(ref)
// 	}
	
// })
// const login = async (ref: any) =>  {
// 		const dataRequest = {
//         userName: ref,
//         password: ref,
//       };
//       await apiPost(USER_V1_LOGIN, dataRequest).then((res) => {
//         let response: any = res;
//         if (response.data.statusCode == 200) {
//           let dataLogin = response.data.data;
//           checkUser(dataLogin);
//         }
//       });
// }

// const checkUser = (dataLogin: any) => {
//   commons.setUserInform(dataLogin);
//   commons.setCokiesUser(dataLogin);
// };

return (_ctx: any,_cache: any) => {
  const _component_a_col = _resolveComponent("a-col")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_layout_content = _resolveComponent("a-layout-content")!
  const _component_a_layout = _resolveComponent("a-layout")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_layout, {
      class: _normalizeClass(["layout-default layout-default-profile", [_unref(route).meta.layoutClass]]),
      id: "layout-default"
    }, {
      default: _withCtx(() => [
        _createVNode(DefaultHeader),
        _createVNode(_component_a_layout_content, null, {
          default: _withCtx(() => [
            _createVNode(_component_a_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_col, {
                  xs: 0,
                  lg: 6
                }, {
                  default: _withCtx(() => [
                    _createVNode(Slide)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, {
                  xs: 24,
                  lg: 18
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_router_view)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(DefaultFooter),
        _createVNode(Social)
      ]),
      _: 1
    }, 8, ["class"])
  ]))
}
}

})